import React, { useContext, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { usePlatform } from 'src/business/context/platform-context';
import { SessionContext } from 'src/business/context/session-context';
import { LoginForm } from 'src/component/auth/login-form';
import { LoginGenericBanner } from 'src/component/auth/login-generic-banner';

export const LoginScreen = (): React.ReactElement => {
	const { isLoggedIn } = useContext(SessionContext);
	const { isEyeQMarketplace, isAtom, isZeus, isIpl } = usePlatform();

	const linkStyleClass = isEyeQMarketplace
		? 'styled-link-wincanton'
		: isAtom
			? 'styled-link-apollo'
			: 'styled-link-zeus';

	const backgroundColor = isIpl ? 'background-white' : 'signup-background-color';

	const navigate = useNavigate();

	const canCreateHaulierAccount = (): boolean => {
		return !isAtom;
	};

	useEffect(() => {
		if (!isLoggedIn) {
			return;
		}
		navigate('/');
	}, []);

	return (
		<Container fluid={true}>
			<Row className={`${backgroundColor}`}>
				<LoginGenericBanner />
				<Col
					xs={6}
					md={4}
					className="d-grid gap-3"
				>
					<LoginForm />
					<Row className="margin-top pt-5">
						{canCreateHaulierAccount() && (
							<Link
								className={`d-grid gap-3 styled-link ${linkStyleClass} text-center`}
								to="/signup"
							>
								Don’t have an account? <br />
								Sign up as a haulier
							</Link>
						)}
					</Row>
				</Col>
			</Row>
		</Container>
	);
};
